import { Box, Container, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import LogoJoinImg from "../../../src/assets/img/join-img.png";
import HeadingImg from "../../../src/assets/img/title-left.png";
import config from "../../config.json";
import DiscordSectionsCard from "./components/DiscordSectionsCard";

const DiscordSections = () => {
  const [serverStats, setServerStats] = useState({
    serverOnline: false,
    onlinePlayers: 0,
  });

  const fetchOnlineStatus = async () => {
    try {
      const { data } = await axios.get(config.apiEndPoint + "statistics");
      setServerStats({
        serverOnline: !!data?.serverOnline,
        onlinePlayers: data?.onlinePlayers ?? 0,
      });
    } catch (error) {
      console.error("Failed to fetch server stats:", error);
    }
  };

  useEffect(() => {
    fetchOnlineStatus();
    const interval = setInterval(fetchOnlineStatus, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  return (
    <Container
      sx={{
        py: { xs: 4, sm: 6, md: 8 },
        textAlign: "center",
        width: "100%",
        position: "relative",
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 5,
        }}
      >
        <Box component="img" src={LogoJoinImg} alt="Test Online" />
        <Box
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            mb: 10,
          }}
        >
          <Box component="img" src={HeadingImg} alt="Test Online" />
          <Typography
            variant="h2"
            fontWeight="bold"
            sx={{
              letterSpacing: 8,
              fontSize: 65,
              lineHeight: "1em",
              backgroundImage:
                "-webkit-linear-gradient(90deg, #ffd786 0%, #a6753a 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            WE ARE IN DISCORD!
          </Typography>
          <Box component="img" src={HeadingImg} alt="Test Online" />
        </Box>
      </Box>

      <Typography sx={{ fontSize: 22, letterSpacing: 0.5 }}>
        Get up-to-date information before anyone else!
      </Typography>
    
      {/* Discord Info Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          justifyContent: "center",
          textAlign: "left",
        }}
      >
        {/* Channel List */}
        <DiscordSectionsCard serverStats={serverStats} />
      </Box>

    </Container>
  );
};

export default DiscordSections;
